import { c as _c } from "react/compiler-runtime";
import { HotelReservedCardFooterTypesPropertiesType } from "@website/accommodation-ui/hotel-reserve-rooms-layout/hotel-reserve-card/hotel-reserve-card-footer/hotel-reserved-card-footer.types";
import { useJwtToken } from "@website/hooks/auth-manager";
import { isInvalidCheckin } from "@website/utils/date-format";
import { useLoginModal } from "@website/widget/login";
import { useRouter } from "next/router";
import { useState } from "react";
export const useHotelReserveCardFooter = t0 => {
  const $ = _c(19);
  const {
    id,
    onClick,
    onModalClose,
    roomCount,
    setRoomCount
  } = t0;
  const router = useRouter();
  const {
    onLoginModalOpen
  } = useLoginModal();
  const {
    phoneNumber
  } = useJwtToken();
  const [roomSelect, setRoomSelect] = useState();
  const [loading, setLoading] = useState(false);
  let t1;
  if ($[0] !== router.query.date_from || $[1] !== router.query.date_to) {
    t1 = isInvalidCheckin(router.query.date_from, router.query.date_to, false);
    $[0] = router.query.date_from;
    $[1] = router.query.date_to;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const isInvalid = t1;
  const openDatePicker = _temp;
  let t2;
  if ($[3] !== id || $[4] !== isInvalid || $[5] !== onClick || $[6] !== onModalClose || $[7] !== roomCount) {
    t2 = () => {
      if (isInvalid) {
        onModalClose?.(false);
        openDatePicker();
      } else {
        setRoomSelect(id);
        setLoading(true);
        onClick?.(Number(roomCount))?.finally?.(() => setLoading(false));
      }
    };
    $[3] = id;
    $[4] = isInvalid;
    $[5] = onClick;
    $[6] = onModalClose;
    $[7] = roomCount;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  const createBook = t2;
  let t3;
  if ($[9] !== createBook || $[10] !== onLoginModalOpen || $[11] !== phoneNumber) {
    t3 = () => {
      if (!phoneNumber) {
        return onLoginModalOpen().then(() => createBook());
      }
      createBook();
    };
    $[9] = createBook;
    $[10] = onLoginModalOpen;
    $[11] = phoneNumber;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  const onHandleClick = t3;
  const handleRecommendedHotel = _temp2;
  let t4;
  if ($[13] !== loading || $[14] !== onHandleClick || $[15] !== roomCount || $[16] !== roomSelect || $[17] !== setRoomCount) {
    t4 = {
      roomCount,
      roomSelect,
      loading,
      setRoomCount,
      onHandleClick,
      openDatePicker,
      handleRecommendedHotel
    };
    $[13] = loading;
    $[14] = onHandleClick;
    $[15] = roomCount;
    $[16] = roomSelect;
    $[17] = setRoomCount;
    $[18] = t4;
  } else {
    t4 = $[18];
  }
  return t4;
};
function _temp() {
  const search_date_range = document.querySelector("[data-testid=\"search_date_range\"]");
  search_date_range?.scrollIntoView({
    block: "center"
  });
  search_date_range?.click();
}
function _temp2() {
  return document.querySelector("#hotel_recomendation")?.scrollIntoView({
    block: "center"
  });
}